import { createStore } from 'redux';

import {
    persistStore,
    persistCombineReducers
} from 'redux-persist';

import storage from 'redux-persist/lib/storage';

import app from './application/reducer';
import navigation from './navigation/reducer';
import categories from './categories/reducer';
import cache from './cache/reducer';
import cookieconsent from './cookieconsent/reducer';

const reducers = persistCombineReducers({
    key: 'kerstpakketten',
    version: 1,
    storage: storage,
    whitelist: ['app', 'cookieconsent']
}, {
    app,
    navigation,
    categories,
    cache,
    cookieconsent
});

const configureStore = () => {
    const store = createStore(reducers);
    const persistor = persistStore(store);
    return { store, persistor };
}

export default configureStore;